import React, { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getSubscriptionsAction } from 'slices/subscriptions'
import { SubscriptionData } from 'types'

const SubscriptionsTable: React.FC = () => {
	const dispatch = useAppDispatch()
	const { records, loading } = useAppSelector(state => state.subscription)

	const columns: ColumnsType<SubscriptionData> = [
		{
			title: 'Title',
			dataIndex: 'planTitle',
			key: 'planTitle',
		},
		{
			title: 'Billing Cycle',
			dataIndex: 'billingCycle',
			key: 'billingCycle',
		},
		{
			title: 'Vendor',
			dataIndex: 'vendor',
			key: 'vendor',
		},
		{
			title: 'Currency',
			dataIndex: 'currency',
			key: 'currency',
		},
		{
			title: 'Amount',
			dataIndex: 'amount',
			key: 'amount',
			render: (value, record) => {
				const realAmount = value / 100
				return `${record.currency} ${realAmount.toLocaleString()}`
			},
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			ellipsis: true,
			render: (desc: string) => desc || '-',
		},
	]

	useEffect(() => {
		dispatch(getSubscriptionsAction())
	}, [dispatch])
	return (
		<Table
			loading={loading}
			dataSource={records}
			columns={columns}
			rowKey='_id'
		/>
	)
}

export default SubscriptionsTable
